import { render } from "./IconRanking.vue?vue&type=template&id=618e2220&ts=true"
import script from "./IconRanking.vue?vue&type=script&lang=ts"
export * from "./IconRanking.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__